import { rootUiActions, rootUiTypes } from 'app-components/flux/root-ui';
import type { scheduledTransactionsTypes } from 'app-components/flux/scheduled-transactions';
import { ROOT_MODAL_DRAWER_PROP } from 'components/Drawers/standardDrawerContract';
import type { RootModalDrawerOptions } from 'components/Drawers/standardDrawerContract';
import { Map as ImmutableMap } from 'immutable';
import { createAction } from 'redux-actions';

export const DIALOG_TYPE = 'SCHEDULED_TRANSACTION_ADD_DIALOG';

type ShowAddScheduledTransactionDialogOptions = {
  dialogType?: scheduledTransactionsTypes.STType;
  rootModalDrawer?: RootModalDrawerOptions;
};

export const showAddScheduledTransactionDialog = createAction(
  rootUiActions.createDialog.toString(),
  (options: ShowAddScheduledTransactionDialogOptions | undefined) =>
    rootUiTypes.mkRootUiData({
      type: DIALOG_TYPE,
      id: DIALOG_TYPE,
      props: options
        ? ImmutableMap({
            ...(options.dialogType ? { dialogType: options.dialogType } : {}),
            ...(options.rootModalDrawer ? { [ROOT_MODAL_DRAWER_PROP]: options.rootModalDrawer } : {}),
          })
        : undefined,
    }),
);
